import { useEffect, useState } from 'react'
import { isApiError } from '../../api/client'
import { Button } from '../../design'
import { USAGE_COPY } from './copy'
import { useUpdateMonthlyTokenBudget } from './queries'
import { TOKEN_BUDGET_FIELD_ID, TokenBudgetField } from './TokenBudgetField'

export const BudgetForm = ({ budget, onClose }: { budget: number; onClose: () => void }) => {
  const update = useUpdateMonthlyTokenBudget()
  const [draft, setDraft] = useState<number | null>(budget)
  const failure = isApiError(update.error) ? update.error.message : null

  useEffect(() => {
    document.getElementById(TOKEN_BUDGET_FIELD_ID)?.focus()
  }, [])

  const save = () => {
    if (draft === null) {
      document.getElementById(TOKEN_BUDGET_FIELD_ID)?.focus()
      return
    }
    if (draft === budget) {
      onClose()
      return
    }
    update.mutate(draft, { onSuccess: onClose })
  }

  return (
    <div className="usage-budget-editor">
      <TokenBudgetField budget={budget} onChange={setDraft} />
      {failure === null ? null : (
        <p className="text-tone tone-danger" role="alert">
          {failure}
        </p>
      )}
      <div className="usage-budget-actions">
        <Button variant="primary" pending={update.isPending} pendingLabel={USAGE_COPY.savingBudget} onClick={save}>
          {USAGE_COPY.saveBudget}
        </Button>
        <Button disabled={update.isPending} onClick={onClose}>
          {USAGE_COPY.cancelBudget}
        </Button>
      </div>
    </div>
  )
}

export const ADJUST_BUDGET_BUTTON_ID = 'usage-adjust-budget'

export const AdjustBudgetButton = ({ onClick }: { onClick: () => void }) => (
  <Button id={ADJUST_BUDGET_BUTTON_ID} className="usage-adjust" aria-label={USAGE_COPY.adjustBudgetLabel} onClick={onClick}>
    {USAGE_COPY.adjustBudget}
  </Button>
)
